module.exports = __webpack_public_path__ + "static/media/experience concept.7a2ac425.png";